import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserAuthenticationHookDetails } from "../../services/AuthService";
import { setUserDataForAPI } from "../../services/AxiosInterceptor";
import { deleteUnConfirmedUser } from "../../services/UserService";
import "./Auth.scss";
import LeftPanel from "./LeftPanel";
import LoadingSpinner from "../../utils/components/common/loadingSpinner/LoadingSpinner";
import { useTranslation } from "react-i18next";

const MobileOTP = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation("auth");
  const [otp, setOTP] = useState("");
  const [otpError, setOTPError] = useState(false);
  const [otpVerifyError, setOTPVerifyError] = useState(false);
  const [otpVerifyErrorMessage, setOTPVerifyErrorMessage] = useState("");
  const [resendOTP, setResendOTP] = useState(false);
  const [nextDisable, setNextDisable] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLaoding, setIsLoading] = useState(false);

  const confirmMobile = async () => {
    try {
      if (otp.length < 6) {
        setOTPError(true);
        return false;
      }
      setIsSubmitted(true);
      setIsLoading(true);
      setOTPVerifyError(false);
      let final_phone_number = location?.state?.phone_number.replace(/-/g, ""); // remove - as cognito doesnt accept it.
      await Auth.confirmSignUp(final_phone_number, otp);
      const userProfileData = await Auth.signIn(
        final_phone_number,
        location?.state?.password
      );
      setUserDataForAPI(userProfileData);

      const queryParam = {
        accesstoken: userProfileData?.signInUserSession?.accessToken?.jwtToken,
        attribute: "email",
        action: "SendOTP",
      };
      getUserAuthenticationHookDetails(queryParam)
        .then(function (response) {
          setIsSubmitted(false);
          setIsLoading(false);
          if (response.status === 200) {
            navigate("/confirmemail", {
              state: {
                ...userProfileData.signInUserSession.accessToken,
                phone_number: final_phone_number,
                email: location?.state?.email,
                name: location?.state?.name,
                password: location?.state?.password,
                confirmpassword: location?.state?.confirmpassword,
                inviteid: location?.state?.inviteid,
              },
            });
          }
        })
        .catch(function (error) {
          setIsSubmitted(false);
          setIsLoading(false);
          // console.log(error);
        });
    } catch (error) {
      setIsSubmitted(false);
      setIsLoading(false);
      // console.log("error confirmMobile in", error);
      const { code } = error;
      switch (code) {
        case "CodeMismatchException": {
          setOTPVerifyErrorMessage("Incorrect Mobile Security Code!");
          setOTPVerifyError(true);
          break;
        }
        case "LimitExceededException": {
          setOTPVerifyErrorMessage(
            "Attempt limit exceeded, please try after some time."
          );
          setOTPVerifyError(true);
          break;
        }
        case "ExpiredCodeException": {
          setOTPVerifyErrorMessage(
            "Security code expired, please click resend"
          );
          setOTPVerifyError(true);
          break;
        }
        default:
          setOTPVerifyErrorMessage("");
      }
    }
  };
  const resendConfirmationCode = async () => {
    try {
      setOTPVerifyError(false);
      setIsLoading(true);
      let final_phone_number = location?.state?.phone_number.replace(/-/g, ""); // remove - as cognito doesnt accept it.
      await Auth.resendSignUp(final_phone_number);
      setIsLoading(false);
      setResendOTP(true);
      setTimeout(() => {
        setResendOTP(false);
      }, 5000);
    } catch (error) {
      setResendOTP(false);
      setIsLoading(false);
      const { code } = error;
      switch (code) {
        case "LimitExceededException": {
          setOTPVerifyErrorMessage(
            "Attempt limit exceeded, please try after some time."
          );
          setOTPVerifyError(true);
          break;
        }
        default:
          setOTPVerifyErrorMessage("");
      }
    }
  };

  const handleKeypress = (e) => {
    if (e.key === "Enter") {
      if (!nextDisable) confirmMobile();
    }
  };

  const handleBackToSignUp = () => {
    setIsLoading(true);
    const param = {
      attribute: "email",
      attribute_value: location?.state?.email,
    };
    deleteUnConfirmedUser(param)
      .then((response) => {
        setIsLoading(false);
        if (response.status === 200) {
          localStorage.removeItem("unconfirmed_email");
          if (location?.state?.inviteid) {
            navigate("/signup/" + location?.state?.inviteid, {
              state: location?.state,
            });
          } else {
            navigate("/signup", { state: location?.state });
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        // console.log(err);
      });
  };

  useEffect(() => {
    if (location.state === null) {
      setTimeout(() => {
        navigate("/signup");
      }, 0);
    }
  }, [location.state, navigate]);
  return (
    <>
      <section className="authContainer">
        <LeftPanel />

        <div className="rightPanel">
          <img
            id="logo"
            src={require("../../assets/images/chorus-rgb.png")}
            className="img-fluid logo mb-4"
            alt="chorus"
          />
          <div
            className="container-fluid pt-5 mt-5 flex-fill"
            onKeyDown={handleKeypress}
          >
            <div className="fieldset d-flex flex-column text-center justify-content-center mb-4 align-items-center">
              <p
                className="fs-6 mb-0 text-dark main-text"
                id="mobile-enter-code-text"
              >
                {t("securityCodeText")}
              </p>
              <p className="fs-7" id="code-sent-text">
                {t("codeSent")}{" "}
                {location?.state?.phone_number || t("yourMobile")}
              </p>
            </div>
            <div className="fieldset d-flex flex-column justify-content-center align-items-center mb-4 otpInputWrapper">
              <OTPInput
                value={otp}
                className="otpInput"
                focusStyle={{
                  border: "1px solid #CFD3DB",
                  outline: "none",
                }}
                onChange={(val) => {
                  setOTP(val);
                  setOTPError(false);
                  setOTPVerifyError(false);
                  if (val.length < 6) {
                    setNextDisable(true);
                  } else {
                    setNextDisable(false);
                  }
                }}
                separator={<span style={{ width: "8px" }}> </span>}
                shouldAutoFocus={true}
                numInputs={6}
                isInputNum={true}
                isDisabled={false}
                isInputSecure={true}
              />
              {otpError && (
                <span className="validationError">
                  {t("otpLengthErr")}
                </span>
              )}
            </div>
            <div className="fieldset d-flex flex-row justify-content-between align-items-center mb-4">
              <button
                onClick={handleBackToSignUp}
                id="wrongnumber"
                className="linkBtn"
              >
                {t("enteredWrongNum")}
              </button>
              <button
                onClick={resendConfirmationCode}
                id="resendcode"
                name="resendcode"
                className="linkBtn"
              >
                {t("resendOtp")}
              </button>
            </div>
            {resendOTP && (
              <div className="fieldset mb-4">
                <p
                  className="fs-7 mb-0 successMsg text-center"
                  id="code-resent-text"
                >
                  {t("codeSentTo")}{" "}
                  {location.state?.phone_number || t("yourMobile")}
                </p>
              </div>
            )}
            {otpVerifyError && (
              <div className="fieldset mb-4">
                <p
                  id="code_error"
                  className="fs-7 mb-0 validationError text-center"
                >
                  {otpVerifyErrorMessage}
                </p>
              </div>
            )}
            <div className="fieldset mb-4">
              <button
                type="submit"
                id="next"
                disabled={nextDisable || isSubmitted}
                className={
                  nextDisable || isSubmitted ? "submitBtn dark" : "submitBtn"
                }
                onClick={confirmMobile}
              >
                {isSubmitted ? (
                  <span>
                    {t("loading")}
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    ></div>
                  </span>
                ) : (
                  <span>{t("next")}</span>
                )}
              </button>
            </div>
          </div>
          <div className="fieldset text-center" id="copyright-text">
            {t("rightReservedText")}
          </div>
        </div>

        {isLaoding && <LoadingSpinner />}
      </section>
    </>
  );
};

export default MobileOTP;
